import { Injectable, inject } from '@angular/core';
import { downloadFile } from '../../functions/download-file';
import { FileUploadConfirmation } from '../../models/api/view/claim/documentation/documents/file-upload-confirmation';
import { ClaimSummarySidekick } from '../../models/api/view/claim/summary/claim-summary-sidekick';
import {
  ClaimSummaryWC,
  SidekickSummaryDetail,
} from '../../models/sidekick-summary.model';
import { Api } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class SidekickService {
  private api = inject(Api);


  getSummaryCard(
    recordSource: string,
    recordId: string,
  ): Promise<ClaimSummarySidekick> {
    return this.api.claimSummary.getClaimSummarySidekick(
      recordSource,
      recordId,
    );
  }

  getWCSummaryCard(
    recordSource: string,
    recordId: string,
  ): Promise<ClaimSummaryWC> {
    return this.api.claimSummary.getWCClaimSummary(recordSource, recordId);
  }

  async getSummaryDetail(
    recordSource: string,
    recordId: string,
  ): Promise<SidekickSummaryDetail> {
    const detail = await this.api.sidekick.getSummaryDetail({
      recordSource,
      recordId,
    });
    // Normalize currentAge so 0 displays instead of blank (match Classic viaOne)
    if (detail && detail.currentAge == null) {
      detail.currentAge = 0;
    }
    return detail;
  }

  async exportPDF(
    recordSource: string,
    recordId: string,
    claimNumber: string,
    chartImages?: string[],
  ): Promise<void> {
    const blob = await this.api.sidekick.exportSummaryPDF(
      { recordSource, recordId },
      chartImages,
    );
    const fileName = `ClaimSummary_${claimNumber.replace(/-/g, '')}.pdf`;
    downloadFile(blob, fileName, blob.type);
  }

  /**
   * Upload Omni AI summary PDF to SIR
   * Called after AI generation completes
   */
  uploadSummaryToSIR(
    recordSource: string,
    recordId: string,
  ): Promise<FileUploadConfirmation> {
    return this.api.sidekick.uploadToSIR({ recordSource, recordId });
  }
}
